import { call, put, takeLatest } from "redux-saga/effects";
import {
  addNewAddressFailure,
  addNewAddressStart,
  addNewAddressSuccess,
  getAddressesStart,
  removeAddressStart,
  setAddressAsDefaultStart,
} from "redux/address";
import {
  getAddresses,
  removeAddress,
  setAddressAsDefault,
  updateNewAddress,
} from "redux/services/address";
import { getAccessToken } from "utils/auth";
import snack from "components/wrapper/snack";
import { history } from "routes/";

function* addressSagaWatcher() {
  yield takeLatest(
    [
      addNewAddressStart.type,
      getAddressesStart.type,
      removeAddressStart.type,
      setAddressAsDefaultStart.type,
    ],
    addressWorker
  );
}

function* addressWorker(action: any): any {
  try {
    if (getAccessToken()) {
      switch (action.type) {
        case addNewAddressStart.type:
          // 1. Add the new address
          const response = yield call(updateNewAddress, action.payload.address);

          // 2. Fetch all addresses
          const addressesResponse = yield call(getAddresses);
          const addresses = addressesResponse.ResponseBody || [];

          // 3. If only one address and not default, set as default
          if (addresses.length === 1 && !addresses[0].Default) {
            const defualtAddressResponseData = yield call(setAddressAsDefault, {
              setAsDefault: {
                newAddressId: addresses[0]._id,
                oldAddressId: undefined,
              },
            });
            if (defualtAddressResponseData.Status === "Complete") {
              snack.success("Address Set as Default");
            }
          }

          // 4. Update Redux state
          yield put(addNewAddressSuccess({ addresses }));
          // 5. Navigation logic (if needed)
          if (
            action.payload.nextPath &&
            !action.payload?.location?.state?.from
          ) {
            history.push(action.payload.nextPath);
          } else {
            history.push({
              pathname: action.payload?.location?.state?.from,
              state: {
                ...action.payload?.location?.state,
                address: action.payload?.address,
              },
            });
          }
          yield put(getAddressesStart());
          break;

        case removeAddressStart.type:
          yield call(removeAddress, action.payload);
          snack.error("Address removed Successfully");
          yield put(getAddressesStart());
          break;

        case setAddressAsDefaultStart.type:
          yield call(setAddressAsDefault, action.payload);
          snack.success("Default Address set Successfully");
          yield put(getAddressesStart());
          break;

        case getAddressesStart.type:
          {
            const response: any = yield call(getAddresses);
            yield put(
              addNewAddressSuccess({ addresses: response.ResponseBody })
            );
          }
          break;

        default:
          break;
      }
    } else {
      console.error("Unauthorized User");
    }
  } catch (err: any) {
    console.error(`Error occuring while calling an action ${action.type}`, err);

    if (action.type === addNewAddressStart.type || getAddressesStart.type) {
      yield put(addNewAddressFailure);
    }
  }
}

export default addressSagaWatcher;
